import{jsx as t}from"react/jsx-runtime";import{LogoMap as a}from"./ServiceLogo.constants.js";
/**
 * 서비스 로고를 표시하는 컴포넌트입니다.
 *
 * @param {Object} props
 * @param {ServiceLogoNames} props.name - 표시할 서비스 로고의 이름
 * @param {string} [props.className] - 로고에 적용할 추가 CSS 클래스
 * @param {('default'|'disabled'|'bluegray'|'white')} [props.variant='default'] - 로고의 색상 변형 '_symbol' postfix를 가지는 name일 때에만 사용 가능 ('default'|'disabled'|'bluegray'|'white')
 * @returns {JSX.Element|null} 서비스 로고 컴포넌트 또는 로고를 찾을 수 없는 경우 null
 * @example
 * // 기본 사용법
 * <ServiceLogo name="wishket_symbol" />
 *
 * // 커스텀 클래스와 함께 사용
 * <ServiceLogo name="wishket_symbol" className="custom-logo" />
 *
 * // 버튼 색상 변형 사용
 * <ServiceLogo name="wishket_symbol" variant="bluegray" />
 */const r=({name:r,className:e,variant:o="default"})=>{const s=a.get(r);return s&&/*#__PURE__*/t(s,{variant:o,className:e})};export{r as ServiceLogo};
